import { render } from "./BannerTopSlider.vue?vue&type=template&id=15327840&scoped=true"
import script from "./BannerTopSlider.vue?vue&type=script&lang=js"
export * from "./BannerTopSlider.vue?vue&type=script&lang=js"

import "@/assets/scss/_carousel.scss?vue&type=style&index=0&lang=scss"
import "./BannerTopSlider.vue?vue&type=style&index=1&id=15327840&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15327840"]])

export default __exports__